/**
 * leaflet plugin for plain image map projection
 * @copyright 2016- commenthol
 * @license MIT
 */
/* globals define */
/* eslint no-var:off */
import L from "leaflet";

export class RasterCoords {
	map: L.Map;
	width: number;
	height: number;
	tilesize: number;
	zoom: number;

	/**
	 * L.RasterCoords
	 * @param {L.map} map - the map used
	 * @param {Array} imgsize - [ width, height ] image dimensions
	 * @param {Number} [tilesize] - tilesize in pixels. Default=256
	 */
	constructor(map: L.Map, imgsize: [number, number], tilesize: number = 256) {
		this.map = map;
		this.width = imgsize[0];
		this.height = imgsize[1];
		this.tilesize = tilesize;
		this.zoom = this.zoomLevel();
		if (this.width && this.height) {
			this.setMaxBounds();
		}
	}

	/**
	 * calculate accurate zoom level for the given image size
	 */
	zoomLevel(): number {
		return Math.ceil(
			Math.log(Math.max(this.width, this.height) / this.tilesize) /
				Math.log(2)
		);
	}
	/**
	 * unproject `coords` to the raster coordinates used by the raster image projection
	 * @param {Array} coords - [ x, y ]
	 * @return {L.LatLng} - internal coordinates
	 */
	unproject(coords: L.PointExpression): L.LatLng {
		return this.map.unproject(coords, this.zoom);
	}
	/**
	 * project `coords` back to image coordinates
	 * @param {Array} coords - [ x, y ]
	 * @return {L.LatLng} - image coordinates
	 */
	project(coords: L.LatLngExpression): L.Point {
		return this.map.project(coords, this.zoom);
	}
	/**
	 * get the max bounds of the image
	 */
	getMaxBounds() {
		var southWest = this.unproject([0, this.height]);
		var northEast = this.unproject([this.width, 0]);
		return new L.LatLngBounds(southWest, northEast);
	}
	/**
	 * sets the max bounds on map
	 */
	setMaxBounds() {
		var bounds = this.getMaxBounds();
		this.map.setMaxBounds(bounds);
	}
}
